/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

class ObjectHelper {
  static toMap(object) {
    if (null == object) {
      return null;
    }
    let map = new Map();
    Object.keys(object).forEach((key) => {
      map.set(key, object[key]);
    });
    return map;
  }
}

export default ObjectHelper;
